import { useQueries } from '@tanstack/react-query';
import { fetchReleazioConfig } from '@/lib/releazio/api';
import { useEnv } from '@/hooks/useEnv';
import type { ReleazioConfigData, ReleazioConfigResponse } from '@/lib/releazio/types';

const extractAppUrl = (response: ReleazioConfigResponse | undefined): string | undefined => {
	if (!response) return undefined;
	const { data } = response;
	if (Array.isArray(data)) {
		return data[0]?.app_url || undefined;
	}
	return (data as ReleazioConfigData).app_url || undefined;
};

export const useDownloadUrls = () => {
	const { apkDownloadUrl: apkFallback, appStoreDownloadUrl: appStoreFallback } = useEnv();

	const [apkQuery, appStoreQuery] = useQueries({
		queries: [
			{
				queryKey: ['releazio', 'apk'],
				queryFn: () => fetchReleazioConfig('apk'),
				staleTime: 1000 * 60 * 10,
				retry: false,
			},
			{
				queryKey: ['releazio', 'appstore'],
				queryFn: () => fetchReleazioConfig('appstore'),
				staleTime: 1000 * 60 * 10,
				retry: false,
			},
		],
	});

	return {
		apkDownloadUrl: extractAppUrl(apkQuery.data) ?? apkFallback,
		appStoreDownloadUrl: extractAppUrl(appStoreQuery.data) ?? appStoreFallback,
		isLoading: apkQuery.isLoading || appStoreQuery.isLoading,
	};
};
